import React from "react";
import { Skeleton } from "@common/skeleton";

import { Props } from "./types";
import { Element } from "./element";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <div className={styles.loader}>
      <div className={styles.section}>
        <Skeleton className={styles.title} />
        <ul className={styles.list}>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
        </ul>
      </div>
      <div className={styles.section}>
        <Skeleton className={styles.title} />
        <ul className={styles.list}>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
        </ul>
      </div>
      <div className={styles.section}>
        <Skeleton className={styles.title} />
        <ul className={styles.list}>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
          <li className={styles.result}>
            <Element />
          </li>
        </ul>
      </div>
    </div>
  );
}

export { Loader };
